export default function SearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M14.9431 14.4438L19.4995 19.0001M17.25 8.875C17.25 13.2242 13.7242 16.75 9.375 16.75C5.02576 16.75 1.5 13.2242 1.5 8.875C1.5 4.52576 5.02576 1 9.375 1C13.7242 1 17.25 4.52576 17.25 8.875Z"
        stroke="#5E718D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
